import { render, staticRenderFns } from "./MusicWaveNew.vue?vue&type=template&id=25400276&scoped=true&"
import script from "./MusicWaveNew.vue?vue&type=script&lang=js&"
export * from "./MusicWaveNew.vue?vue&type=script&lang=js&"
import style0 from "./MusicWaveNew.vue?vue&type=style&index=0&id=25400276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25400276",
  null
  
)

export default component.exports